import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, mergeProps as _mergeProps, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-58787f12"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "aggregate-daily-sales-report"
};
var _hoisted_2 = {
  class: "title"
};
var _hoisted_3 = {
  class: "num"
};
var _hoisted_4 = {
  class: "desc"
};
var _hoisted_5 = {
  class: "sandTotal"
};
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "制砂总汇", -1);
});
var _hoisted_7 = {
  class: "num"
};
var _hoisted_8 = {
  class: "desc"
};
var _hoisted_9 = {
  class: "desc"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title"
  }, "泥饼量", -1);
});
var _hoisted_11 = {
  class: "num"
};
var _hoisted_12 = {
  class: "desc"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "title mt-2"
  }, "生产趋势", -1);
});
var _hoisted_14 = {
  class: "box mb-4"
};
var _hoisted_15 = {
  key: 0,
  class: "box mb-4"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_c_date_header_with_btn = _resolveComponent("c-date-header-with-btn");
  var _component_van_grid_item = _resolveComponent("van-grid-item");
  var _component_van_grid = _resolveComponent("van-grid");
  var _component_bar_echart_mul = _resolveComponent("bar-echart-mul");
  var _component_c_no_data = _resolveComponent("c-no-data");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_c_date_header_with_btn, {
    ref: "dateRef",
    type: _ctx.params.type,
    forceShow: true,
    onConfirmDate: _ctx.confrimDate,
    onSwitch: _ctx.switchClick
  }, null, 8, ["type", "onConfirmDate", "onSwitch"]), _createElementVNode("div", _hoisted_2, "本" + _toDisplayString(_ctx.title) + "生产总汇", 1), _createVNode(_component_van_grid, {
    class: "grid",
    gutter: 10,
    "column-num": 2
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
        return _openBlock(), _createBlock(_component_van_grid_item, {
          key: index
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.emptyStringFormat(item.num)), 1), _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.emptyStringFormat(item.desc)), 1)];
          }),
          _: 2
        }, 1024);
      }), 128))];
    }),
    _: 1
  }), _createElementVNode("view", _hoisted_5, [_hoisted_6, _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stoneEle.list, function (item) {
        return _openBlock(), _createElementBlock(_Fragment, null, [_ctx.factoryID != 187 || item.material_name != '收尘粉/吨' ? (_openBlock(), _createBlock(_component_van_grid_item, {
          key: item.material_name
        }, {
          default: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.emptyStringFormat(item.pro_num)), 1), _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.emptyStringFormat(item.material_name)), 1), _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.emptyStringFormat(item.ratio)), 1)];
          }),
          _: 2
        }, 1024)) : _createCommentVNode("", true)], 64);
      }), 256))];
    }),
    _: 1
  }), _ctx.factoryID == 187 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_10, _createVNode(_component_van_grid, {
    class: "grid mb-2",
    gutter: 10,
    "column-num": 3
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_van_grid_item, null, {
        default: _withCtx(function () {
          return [_createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.stoneEle.soil.net_weight), 1), _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.stoneEle.soil.material_name), 1)];
        }),
        _: 1
      })];
    }),
    _: 1
  })], 64)) : _createCommentVNode("", true)]), _hoisted_13, _createElementVNode("div", _hoisted_14, [_ctx.mainPro.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mainPro)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))]), _ctx.params.type === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_ctx.mainProYear.lineData.flatMap(function (item) {
    return item;
  }).length ? (_openBlock(), _createBlock(_component_bar_echart_mul, _normalizeProps(_mergeProps({
    key: 0
  }, _ctx.mainProYear)), null, 16)) : (_openBlock(), _createBlock(_component_c_no_data, {
    key: 1
  }))])) : _createCommentVNode("", true)]);
}